
export class HttpOptionsModel {
  path: string;
  data: any;
  loginRequired: boolean;
  isFormData:boolean;

  constructor(path?:string, data?:any, loginRequired?:boolean, isFormData?:boolean) {
    this.path = path;
    this.data = data;
    this.loginRequired = loginRequired || false;
    this.isFormData = isFormData || false;
  }
}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/models/HttpOptionsModel.ts